// accordions
(function () {
  function initColorVariantSelector() {
    const variantButtons = document.querySelectorAll('.color-option-button');

    variantButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const otherBtns = btn.parentElement.querySelectorAll(
          '.color-option-button'
        );
        const btnMedia = otherBtns.forEach((button) => {
          button.classList.remove('active');
        });
        btn.classList.add('active');

        const mainImages = btn
          .closest('.product-card-wrapper')
          .querySelectorAll('.card__media img');

        mainImages.forEach((img) => {
          img.srcset = btn.dataset.imgSrc;
        });
      });
    });
  }

  initColorVariantSelector();
})();

class Accordion extends HTMLElement {
  accordionBtn = undefined;
  accordionContent = undefined;

  constructor() {
    super();
    this.accordionBtn = this.querySelector('button');
    this.accordionWrapper = this.querySelector('.accordion-wrapper');
  }

  closeOtherAccordions() {
    const parent = this.parentElement;

    const children = Array.from(parent.children);
    if (!children.length) return;
    children.forEach((child) => {
      if (child !== this) {
        const accordionEl = child.querySelector('.accordion-wrapper');
        const accordionBtn = child.querySelector('button');
        accordionEl.classList.remove('open');
        accordionBtn.ariaExpanded = 'false';
      }
    });
  }

  connectedCallback() {
    this.accordionBtn.addEventListener('click', () => {
      this.closeOtherAccordions();
      this.accordionWrapper.classList.toggle('open');
      const expandedState =
        this.accordionBtn.ariaExpanded === 'false' ? 'true' : 'false';
      this.accordionBtn.ariaExpanded = expandedState;
    });
  }
}

class colorCardAccordion extends Accordion {
  accordionBtn = undefined;
  accordionContent = undefined;
  cardWrapper = undefined;
  accordionContent = undefined;
  constructor() {
    super();
    this.accordionBtn = this.querySelector('button');
    this.accordionWrapper = this.querySelector('.accordion-wrapper');
    this.cardWrapper = this.closest('.card-wrapper');
    this.accordionContent = this.querySelector('.accordion-content');
  }

  connectedCallback() {
    this.accordionBtn.addEventListener('click', () => {
      this.accordionWrapper.classList.toggle('open');
      const expandedState =
        this.accordionBtn.ariaExpanded === 'false' ? 'true' : 'false';
      const cardInfo = this.accordionBtn.closest('.card__content');
      this.accordionBtn.ariaExpanded = expandedState;
      cardInfo.classList.toggle('accordion-open');
      if (cardInfo.classList.contains('accordion-open')) {
        cardInfo.style.transform = `translateY(-${this.accordionContent.scrollHeight}px)`;
      } else {
        cardInfo.style.transform = `unset`;
      }
    });
  }
}

class ShopLookMobileImage extends HTMLElement {
  variantChangeSubscriber = undefined;
  mobileImage = undefined;
  parentShopTheLook = undefined;
  constructor() {
    super();
    this.mobileImage = this.querySelector('img');
    this.parentShopTheLook = this.closest('shop-the-look');
  }

  connectedCallback() {
    this.variantChangeSubscriber = subscribe(
      PUB_SUB_EVENTS.customOptionValueSelectionChange,
      this.handleUpdateMobileImage.bind(this)
    );
  }

  handleUpdateMobileImage({ data: { event, target, selectedOptionValues } }) {
    if (!this.parentShopTheLook.contains(target)) return;
    this.mobileImage.srcset = target.dataset.imageUrl;
  }
}
customElements.define('shop-look-mobile-image', ShopLookMobileImage);
customElements.define('custom-accordion', Accordion);
customElements.define('color-card-accordion', colorCardAccordion);
